angular.module('jv.sendNote.controller', [])
    .controller('jvSendNoteController', [
        '$scope', '$rootScope','jvCandidatesService','jvHireBroadcastSVC',
        function($scope, $rootScope,jvCandidatesService,jvHireBroadcastSVC) {
            $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
            $scope.sendNote = function() {
                //Do not process if the form is still invalid. 
                if ($scope.sendNoteForm.$invalid) {
                    return;
                }

                $scope.flags.loading=true;

                var _attachments = [];
                angular.forEach($scope.attachmentList,function(attachment,key){
                    _attachments.push(attachment.resourceInfo.eid);
                });

                $scope.sendNoteObject.attachmentList = _attachments;
                $scope.sendNoteObject.entityIdList = $scope.modalData.appIds;
                
                if (typeof $scope.toList === 'string') {
                    $scope.sendNoteObject.toList = $scope.toList.split(',');
                } else {
                    $scope.sendNoteObject.toList = $scope.toList;
                }
                /*BE expects locale to be sent to determine language for Email header/footer*/
                if($scope.sendNoteTemplates && $scope.sendNoteTemplates.messageTpl){
                    $scope.sendNoteObject['locale'] = $scope.sendNoteTemplates.messageTpl['locale'];
                }
                jvCandidatesService.sendNote($scope.sendNoteObject, function(res) {
                    $scope.flags.loading = false;
                    if (res.status === 200) {
                        $rootScope.$broadcast('showSendNoteResult', true);
                    } else {
                        $rootScope.$broadcast('showSendNoteResult', false);
                    }
                    $scope.hideModals(false);
                });
            };

            jvHireBroadcastSVC.subscribe('hidingCandidateModals', function() {
                $scope.hideSendNoteModal();
            });

            $scope.initData = function() {
                $scope.sendNoteObject = {
                    toList : [],
                    attachmentList: [],
                    entityIdList: [],
                    includeResume: true
                };
                $scope.sendNoteTemplates = {};
                $scope.content = '';
                $scope.subject = '';
                $scope.submitted = false;
                $scope.toList = [];
                $scope.attachmentList = [];
                //HACK - Needs to be handled by directive. 
                $('.qq-upload-list').html('');
                $('.uploader-error').text('');
            };

            $scope.massageTemplates = function(sendNoteTemplates) {
                var templates = [];
                angular.forEach(sendNoteTemplates, function(tpl) {
                    var template = {
                        id: tpl.EId,
                        body: tpl.body,
                        subject: tpl.subject,
                        text: tpl.title
                    };

                    if (tpl['isDefault']) {
                        $scope.sendNoteTemplates.messageTpl = template;
                        $scope.sendNoteObject.content = template.body;
                        $scope.sendNoteObject.subject = template.subject;
                    }
                    templates.push(template);
                });
                return templates;
            };

            var selectDefaultTemplate = function(sendNoteTemplates){
                angular.forEach(sendNoteTemplates, function(template) {
                    if (template['isDefault']) {
                        $scope.sendNoteTemplates.messageTpl = template;
                        $scope.sendNoteObject.content = template.body;
                        $scope.sendNoteObject.subject = template.subject;
                    }
                });
                return sendNoteTemplates;
            };

            $scope.init = function() {
                $scope.initData();
                $scope.flags.loading = true;

                var postData = {
                        data: $scope.modalData.appIds,
                        action: 'sendNote'
                };

                jvCandidatesService.validateCandidateDetails(postData, function(res) {
                    if (res.status !== 200 || !res.data) {
                        $scope.flags.loading = false;
                        return;
                    }

                    if(res.data.validApplicationIds.length === 0) {
                        var actionValidation = {};
                        actionValidation.show = true;
                        actionValidation.title = i18n.COMMON_SEND_NOTE;
                        actionValidation.message = i18n.CANDIDATES_SEND_NOTE_PERMISSION_MSG;
                        $rootScope.$emit('actionValidation', actionValidation);
                        return;
                    }
                    $scope.modalData.validationResult = res.data;
                    $scope.modalData.appIds = $scope.modalData.validationResult.validApplicationIds;
                    var message = {};
                       message.text = i18n.CANDIDATES_ADD_NOTE_MSG;
                       message.appendFirst = true;
                       $scope.modalData.validationResult.message = message;
                       
                    var qsParams = {
                        applicationEIds: $scope.modalData.appIds
                    };
                    jvCandidatesService.sendNoteTemplate(qsParams, {}, function(res) {
                        if (res.status !== 200 || !res.data) {
                            return;
                        }

                        $scope.flags.loading = false;
                        $scope.modals.sendNote = true;
                        $scope.templates = selectDefaultTemplate($scope.select2Options.setTemplates(res.data.templates));
                    });
                });
            };

            jvHireBroadcastSVC.subscribe('showSendNoteModalView', function() {
                $scope.init();
            });

            $scope.hideSendNoteModal = function() {
                $scope.initData();
                $rootScope.$broadcast('showSendNoteResult', false);
            };

            // TODO: Temporarily patching jquery's offset functionality with 1.9.1
            // to fix CAM-406. Remove when no longer needed.

            jQuery.fn.offset = function( options ) {
                function getWindow( elem ) {
                    return jQuery.isWindow( elem ) ?
                        elem :
                        elem.nodeType === 9 ?
                            elem.defaultView || elem.parentWindow :
                            false;
                }
                if ( arguments.length ) {
                    return options === undefined ?
                        this :
                        this.each(function( i ) {
                            jQuery.offset.setOffset( this, options, i );
                        });
                }

                var docElem, win,
                    box = { top: 0, left: 0 },
                    elem = this[ 0 ],
                    doc = elem && elem.ownerDocument;

                if ( !doc ) {
                    return;
                }

                docElem = doc.documentElement;

                // Make sure it's not a disconnected DOM node
                if ( !jQuery.contains( docElem, elem ) ) {
                    return box;
                }

                // If we don't have gBCR, just use 0,0 rather than error
                // BlackBerry 5, iOS 3 (original iPhone)
                if ( typeof elem.getBoundingClientRect !== typeof undefined ) {
                    box = elem.getBoundingClientRect();
                }
                win = getWindow( doc );
                return {
                    top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
                    left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
                };
            };

            jQuery.offset = {

                setOffset: function( elem, options, i ) {
                    var position = jQuery.css( elem, "position" );

                    // set position first, in-case top/left are set even on static elem
                    if ( position === "static" ) {
                        elem.style.position = "relative";
                    }

                    var curElem = jQuery( elem ),
                        curOffset = curElem.offset(),
                        curCSSTop = jQuery.css( elem, "top" ),
                        curCSSLeft = jQuery.css( elem, "left" ),
                        calculatePosition = ( position === "absolute" || position === "fixed" ) && jQuery.inArray("auto", [curCSSTop, curCSSLeft]) > -1,
                        props = {}, curPosition = {}, curTop, curLeft;

                    // need to be able to calculate position if either top or left is auto and position is either absolute or fixed
                    if ( calculatePosition ) {
                        curPosition = curElem.position();
                        curTop = curPosition.top;
                        curLeft = curPosition.left;
                    } else {
                        curTop = parseFloat( curCSSTop ) || 0;
                        curLeft = parseFloat( curCSSLeft ) || 0;
                    }

                    if ( jQuery.isFunction( options ) ) {
                        options = options.call( elem, i, curOffset );
                    }

                    if ( options.top != null ) {
                        props.top = ( options.top - curOffset.top ) + curTop;
                    }
                    if ( options.left != null ) {
                        props.left = ( options.left - curOffset.left ) + curLeft;
                    }

                    if ( "using" in options ) {
                        options.using.call( elem, props );
                    } else {
                        curElem.css( props );
                    }
                }
            };
        }
]);